import React, { useState } from 'react';
import styled from 'styled-components';
import { 
  CopyOutlined, 
  EditOutlined, 
  StarOutlined,
  StarFilled,
  DeleteOutlined,
  CloseOutlined 
} from '@ant-design/icons';

const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.h3`
  margin: 0;
  flex: 1;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  &:hover {
    color: #1890ff;
  }
`;

// Remove the unused CheckItem component
const ItemContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 8px;
`;

const Checkbox = styled.input`
  margin-right: 8px;
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

const ItemText = styled.div`
  flex: 1;
  ${props => props.isEditing ? '' : 'cursor: pointer;'}
  text-decoration: ${props => props.checked ? 'line-through' : 'none'};
`;

const ActionButton = styled(IconButton)`
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

function CheckList({ list, onCopy, onUpdate, onDelete }) {
  const [newItem, setNewItem] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editingItemId, setEditingItemId] = useState(null);
  const [editingText, setEditingText] = useState('');

  const addItem = (e) => {
    e.preventDefault();
    if (!newItem.trim()) return;
    
    const updatedList = {
      ...list,
      items: [...list.items, { id: Date.now(), text: newItem, checked: false }]
    };
    onUpdate(updatedList);
    setNewItem('');
  };

  const toggleItem = (itemId) => {
    const updatedList = {
      ...list,
      items: list.items.map(item =>
        item.id === itemId ? { ...item, checked: !item.checked } : item
      )
    };
    onUpdate(updatedList);
  };

  const startEditItem = (item) => {
    setEditingItemId(item.id);
    setEditingText(item.text);
  };

  const saveItemEdit = () => {
    if (!editingText.trim()) return;
    
    const updatedList = {
      ...list,
      items: list.items.map(item =>
        item.id === editingItemId ? { ...item, text: editingText } : item
      )
    };
    onUpdate(updatedList);
    setEditingItemId(null);
  };

  const deleteItem = (itemId) => {
    const updatedList = {
      ...list,
      items: list.items.filter(item => item.id !== itemId)
    };
    onUpdate(updatedList);
  };

  const toggleFavorite = () => {
    onUpdate({
      ...list,
      favorite: !list.favorite
    });
  };

  return (
    <Card>
      <Header>
        {isEditing ? (
          <input
            value={list.title}
            onChange={(e) => onUpdate({ ...list, title: e.target.value })}
            onBlur={() => setIsEditing(false)}
            autoFocus
          />
        ) : (
          <Title>{list.title}</Title>
        )}
        <IconButton onClick={toggleFavorite}>
          {list.favorite ? <StarFilled style={{ color: '#faad14' }} /> : <StarOutlined />}
        </IconButton>
        <IconButton onClick={() => setIsEditing(true)}>
          <EditOutlined />
        </IconButton>
        <IconButton onClick={onCopy}>
          <CopyOutlined />
        </IconButton>
        <IconButton onClick={() => onDelete(list.id)}>
          <DeleteOutlined />
        </IconButton>
      </Header>
      
      {list.items.map(item => (
        <ItemContainer key={item.id}>
          <Checkbox
            type="checkbox"
            checked={item.checked}
            onChange={() => toggleItem(item.id)}
          />
          {editingItemId === item.id ? (
            <input
              value={editingText}
              onChange={(e) => setEditingText(e.target.value)}
              onBlur={saveItemEdit}
              onKeyPress={(e) => e.key === 'Enter' && saveItemEdit()}
              autoFocus
              style={{ flex: 1 }}
            />
          ) : (
            <ItemText 
              checked={item.checked}
              onClick={() => startEditItem(item)}
            >
              {item.text}
            </ItemText>
          )}
          <ActionButton onClick={() => deleteItem(item.id)}>
            <CloseOutlined />
          </ActionButton>
        </ItemContainer>
      ))}
      
      <form onSubmit={addItem}>
        <input
          value={newItem}
          onChange={(e) => setNewItem(e.target.value)}
          placeholder="添加新项目"
          style={{ width: '100%', padding: '8px', marginTop: '8px' }}
        />
      </form>
    </Card>
  );
}

export default CheckList;